export default import.meta.ROLLDOWN_FILE_URL_WFHrEU78LbAH0OIV$gG5mg